import DrawerLayout from "../components/Drawer";
import React from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
} from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import { RouterPath } from "src/constants/RouterPath";

const DashboardPage = React.lazy(() => import("src/pages/dashboard"));
const LoginPage = React.lazy(() => import("../pages/login"));
const ForgotPasswordPage = React.lazy(() => import("../pages/forgotPassword"));
const AreaManagemerPage = React.lazy(() => import("../pages/areaManager"));
const StoresPage = React.lazy(() => import("../pages/stores"));
const CreateAreaManagerPage = React.lazy(() => import("../pages/areaManager/createAreaManager"));
const StoreReportsPage = React.lazy(() => import("../pages/stores/report"));
const AreaReportsPage = React.lazy(() => import("../pages/areaManager/report"));
const QuestionsPage = React.lazy(() => import("../pages/questions"));
const EditQuestionsPage = React.lazy(() => import("../pages/questions/edit.page"));
const ReportDetailsPage = React.lazy(() => import("../pages/reports/details"));
const PdfContainer = React.lazy(() => import("../pages/pdfpage"));
const SetPassword = React.lazy(() => import("../pages/setPassword"));
const ChangePassword = React.lazy(() => import("../pages/changePassword"));
const CompanyAdminSettings = React.lazy(() => import("../pages/companyAdmin/settings"));
const Gallery = React.lazy(() => import("../pages/gallery"));
const Accident = React.lazy(() => import("../pages/accident"));
const NotificationPage = React.lazy(() => import("../pages/notifications"));
const ExternalTrainings = React.lazy(() => import("../pages/externalTrainings"));
const ProductPromotions = React.lazy(() => import("../pages/productPromotions"));
const ProductPromotionDetails = React.lazy(() => import("../pages/productPromotionDetails"));

const FullScreenLoader = () => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
    <CircularProgress />
  </Box>
);

export const adminRouter = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={<DrawerLayout />}
      errorElement={<DrawerLayout />}
    >
      <Route path="/" index element={<DashboardPage />} />
      <Route path="/reports" element={<DashboardPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/lead">
        <Route index element={<AreaManagemerPage />} />
        <Route
          path="/lead/create"
          index
          element={<CreateAreaManagerPage />}
        />
        <Route
          path="/lead/edit"
          element={<CreateAreaManagerPage />}
        />
        <Route
          path="/lead/reports"
          element={<AreaReportsPage />}
        />
      </Route>
      <Route path="/stores">
        <Route index element={<StoresPage />} />
        <Route path="/stores/reports" element={<StoreReportsPage />} />
      </Route>
      <Route path="/questions">
        <Route index element={<QuestionsPage />} />
        <Route path="/questions/edit" element={<EditQuestionsPage />} />
      </Route>
      <Route path="/reports/details" element={<ReportDetailsPage />} />
      <Route path={RouterPath.setPassword} element={<SetPassword />} />
      <Route path={RouterPath.changePassword} element={<ChangePassword />} />
      <Route path={RouterPath.settings} element={<CompanyAdminSettings />} />
      <Route path={"/gallery"} element={<Gallery />} />
      <Route path={"/accident"} element={<Accident />} />
      <Route path={"/notifications"} element={<NotificationPage />} />
      <Route path={"/trainings"} element={<ExternalTrainings />} />
      <Route path={"/promotions"} element={<ProductPromotions />} />
      <Route path={"/promotions/images"} element={<ProductPromotionDetails />} />
    </Route>
  )
);
export const areaManagerRouter = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={<DrawerLayout />}
      errorElement={<DrawerLayout />}
    >
      <Route path="/" index element={<DashboardPage />} />
      <Route path="/reports" element={<DashboardPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/stores">
        <Route index element={<StoresPage />} />
        <Route path="/stores/reports" element={<StoreReportsPage />} />
      </Route>
      
      <Route path={RouterPath.setPassword} element={<SetPassword />} />
      <Route path={RouterPath.changePassword} element={<ChangePassword />} />
      
      <Route path={"/gallery"} element={<Gallery />} />
      <Route path={"/accident"} element={<Accident />} />

      <Route path={"/promotions"} element={<ProductPromotions />} />
      <Route path={"/promotions/images"} element={<ProductPromotionDetails />} />
    </Route>
  )
);

export const loginRouter = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={
        <React.Suspense fallback={<FullScreenLoader />}>
          <Outlet />
        </React.Suspense>
      }
      errorElement={<LoginPage />}
    >
      <Route  path="/" index element={<LoginPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/pdf/:token" element={<PdfContainer />} />
      
    </Route>
  )
);
